module.exports = __webpack_public_path__ + "img/4.4c7409b0.jpeg";